export default __webpack_public_path__ + "static/media/IsmailKhalil.f1fcfd82.jpg";